/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface BindUserToOauth2ServerDoneDto
 */
export interface BindUserToOauth2ServerDoneDto {
    /**
     * 
     * @type {string}
     * @memberof BindUserToOauth2ServerDoneDto
     */
    authenticationSystemUserId: string;
    /**
     * 
     * @type {UserIdDto}
     * @memberof BindUserToOauth2ServerDoneDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the BindUserToOauth2ServerDoneDto interface.
 */
export function instanceOfBindUserToOauth2ServerDoneDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "authenticationSystemUserId" in value;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function BindUserToOauth2ServerDoneDtoFromJSON(json: any): BindUserToOauth2ServerDoneDto {
    return BindUserToOauth2ServerDoneDtoFromJSONTyped(json, false);
}

export function BindUserToOauth2ServerDoneDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BindUserToOauth2ServerDoneDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authenticationSystemUserId': json['authenticationSystemUserId'],
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function BindUserToOauth2ServerDoneDtoToJSON(value?: BindUserToOauth2ServerDoneDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authenticationSystemUserId': value.authenticationSystemUserId,
        'userId': UserIdDtoToJSON(value.userId),
    };
}

